<template>
  <div>
    <v-app-bar
      app
      fixed
      dense
      flat
      :class="{ 'background-dark': isDark, 'background-light': !isDark }"
    >
      <v-btn icon @click="closePreviousOrders" v-if="previousOrdersArePaid">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title v-if="previousOrdersArePaid">{{
        $t("Your order")
      }}</v-toolbar-title>
      <v-toolbar-title v-if="!previousOrdersArePaid">{{
        $t("Your last order")
      }}</v-toolbar-title>
    </v-app-bar>

    <v-content
      :class="{
        'fill-height': true,
        'background-dark': isDark,
        'background-light': !isDark
      }"
    >
      <v-row
        class="d-flex flex-column "
        justify="space-between"
        v-if="ordersPaid.paid.length"
      >
        <v-col>
          <div v-for="(order, i) in ordersPaid.paid" :key="i">
            <OrderProduct
              class="body-1"
              v-for="(product, i) in order.products"
              :key="i"
              :orderProduct="product"
              :removable="false"
              @removeProduct.stop.prevent
              :hasBeenPaid="order.hasBeenPaid"
            />
          </div>
        </v-col>
        <hr class="mx-5" />
        <v-col class="d-flex justify-end">
          <div class=" body-1 font-weight-bold">
            {{ localizedPrice(totalPrice.paid) }}
          </div>
        </v-col>
      </v-row>
      <v-row
        class="d-flex flex-column "
        justify="space-between"
        v-if="ordersPaid.notPaid.length"
      >
        <v-col>
          <!-- {{ $t("To pay") }} -->
          <div v-for="(order, i) in ordersPaid.notPaid" :key="i">
            <OrderProduct
              v-for="(product, i) in order.products"
              :key="i"
              :orderProduct="product"
              :removable="false"
              @removeProduct.stop.prevent
              :hasBeenPaid="order.hasBeenPaid"
            />
          </div>
        </v-col>
        <hr class="mx-5" />
        <v-col class="d-flex justify-end">
          <div class="primary--text body-1 font-weight-bold">
            {{ localizedPrice(totalPrice.notPaid) }}
          </div>
        </v-col>
      </v-row>
      <v-footer
        app
        :class="{
          'background-dark': isDark,
          'background-light': !isDark
        }"
      >
        <v-container fluid class="fill-height">
          <v-row
            justify="center"
            class="body-1 primary--text"
            v-if="!previousOrdersArePaid"
          >
            {{ $t("Scan code to make a new order") }}
          </v-row>
          <v-row class="d-flex flex-column" justify="end" align="center">
            <v-btn
              outlined
              color="primary"
              @click="showPaymentOptions"
              v-if="totalPrice.notPaid > 0"
            >
              {{
                $t("Pay {totalPrice} with", {
                  totalPrice: localizedPrice(totalPrice.notPaid)
                })
              }}
            </v-btn>
          </v-row>
        </v-container>
        <!-- <v-container fluid class="fill-height">
          <v-row class="d-flex" justify="space-between" align="center">
            <v-col>
              <v-btn color="black">
                <v-icon color="white" class="display-1">
                  mdi-credit-card
                </v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn color="black">
                <v-icon color="white" class="display-1">
                  mdi-cash-multiple
                </v-icon>
              </v-btn>
            </v-col>
            <gpaybutton
              :price="totalPrice"
              :isDark="isDark"
              currencyCode="EUR"
            />
          </v-row>
        </v-container> -->
      </v-footer>

      <v-bottom-sheet v-model="showPaymentOptionsSheet" inset>
        <v-sheet
          class="text-center"
          :color="isDark ? 'black' : 'white'"
          height="270px"
        >
          <v-row justify="start">
            <v-btn
              class="mt-2 ml-1"
              text
              @click="showPaymentOptionsSheet = !showPaymentOptionsSheet"
            >
              <v-icon>
                mdi-close
              </v-icon>
            </v-btn>
          </v-row>
          <v-container class="py-3 d-flex flex-column align-start">
            <div class="ml-6">
              <v-btn text class="my-3 mx-3" @click="callWaiter('cash')">
                <v-icon class="mr-4 display-1">mdi-bell-outline</v-icon>
                {{ $t("Cash") }}
              </v-btn>
            </div>
            <div class="ml-6">
              <v-btn text class="my-3 mx-3" @click="callWaiter('creditCard')">
                <v-icon class="mr-4 display-1">mdi-bell-outline</v-icon>
                {{ $t("Credit card") }}
              </v-btn>
            </div>
          </v-container>
        </v-sheet>
      </v-bottom-sheet>
    </v-content>
    <v-dialog v-model="waiterConfirmation" width="500">
      <v-card flat class="pa-3">
        <v-card-title
          v-if="payWith == 'cash'"
          :class="{
            'grey--text': true,
            'text--darken-2': !isDark,
            'text--lighten-2': isDark
          }"
          style="    word-break: keep-all;"
        >
          {{ $t("Call waiter to pay with cash?") }}
        </v-card-title>
        <v-card-title
          v-if="payWith == 'creditCard'"
          :class="{
            'grey--text': true,
            'text--darken-2': !isDark,
            'text--lighten-2': isDark
          }"
          >{{ $t("Call waiter to pay with credit credit card?") }}</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="waiterConfirmation = false">{{
            $t("Cancel")
          }}</v-btn>
          <v-btn
            color="primary"
            text
            @click="
              callWaiter(payWith, true);
              waiter = false;
            "
            >{{ $t("Call") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OrderProduct from "@/components/OrderProduct";
// import gpaybutton from "@/components/GPay.vue";
import Activity from "@/model/activity";

export default {
  props: ["orders"],

  data() {
    return {
      showPaymentOptionsSheet: false,
      payWith: null,
      waiterConfirmation: false
    };
  },

  components: { OrderProduct },

  computed: {
    ordersPaid() {
      let orders = { paid: [], notPaid: [] };
      this.orders.forEach(order => {
        if (order.hasBeenPaid) orders.paid.push(order);
        else orders.notPaid.push(order);
      });
      return orders;
    },
    products() {
      let products = [];
      this.orders.forEach(order => {
        order.products.forEach(product => {
          products.push(product);
        });
      });
      return products;
    },
    previousOrdersArePaid() {
      return !!this.ordersPaid.notPaid.length;
    },

    totalPrice() {
      let total = { paid: 0, notPaid: 0 };
      this.orders.forEach(order => {
        if (order.hasBeenPaid) total.paid += Number(order.totalPrice);
        else total.notPaid += Number(order.totalPrice);
      });

      return total;
    },

    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
  },

  methods: {
    callWaiter(type, confirmed = false) {
      this.payWith = type;
      this.waiterConfirmation = true;
      if (confirmed) {
        let activity = Activity.fromMap({
          location: this.$store.state.location,
          type: type,
          date: new Date()
        });
        activity.save();
        this.waiterConfirmation = false;
        this.showPaymentOptionsSheet = false;
      }
    },
    showPaymentOptions() {
      this.showPaymentOptionsSheet = true;
    },

    closePreviousOrders() {
      this.$emit("closePreviousOrders");
    },

    localizedPrice(price) {
      return (
        price.toLocaleString("es-ES", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + " €"
      );
    }
  },

  mounted() {
    const closePreviousOrders = this.closePreviousOrders;
    window.onpopstate = function() {
      closePreviousOrders();
    };

    history.pushState({}, "");
    this.$vuetify.goTo(0, { duration: 0 });
  }
};
</script>

<style scoped>
.background-dark {
  background-color: #1e1e1e !important;
}
.background-light {
  background-color: white !important;
}
.background-footer-dark {
  background-color: black !important;
}
.background-footer-light {
  background-color: white !important;
}
</style>
